import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const fillSchema = z.object({
  /** クローズ済みポジションの損益 */
  closedPnl: decimalSchema.optional(),
  /** アセット名（Perp: AVAX, Spot: @107） */
  coin: z.string(),
  /** クロスマージン取引かどうか */
  crossed: z.boolean(),
  /** 注文方向（例: Open Long, Sell） */
  dir: z.string(),
  /** トランザクションハッシュ (TWAPは常に0x000...) */
  hash: z.string(),
  /** 注文ID */
  oid: z.number(),
  /** 約定価格 */
  px: decimalSchema,
  /** 売買区分（B = Buy, A = Ask/Sell） */
  side: z.union([z.literal('B'), z.literal('A')]),
  /** 約定前のポジションサイズ */
  startPosition: decimalSchema,
  /** 約定数量 */
  sz: decimalSchema,
  /** 約定時間（UNIX時間・ミリ秒） */
  time: z.number(),
  /** 手数料 */
  fee: decimalSchema,
  /** 手数料通貨（例: USDC） */
  feeToken: z.string(),
  /** ビルダーフィー（存在する場合のみ） */
  builderFee: decimalSchema.optional(),
  /** トレードID */
  tid: z.number(),
  /** TWAP ID (fill内部では常にnull) */
  twapId: z.number().nullable(),
})

const twapFillHistorySchema = z.object({
  /** Fill データ */
  fill: fillSchema,
  /** TWAP 注文ID */
  twapId: z.number(),
})

export const responseSchema = z.array(twapFillHistorySchema)
